import type { CallbackEvent } from "@shopify/polaris-types";
import {
  CollapsibleSectionCard,
  SectionHeader,
  Divider,
  NumericField,
} from "../../../components/shared/EditorShared";

// ─── Section 6: Comportamiento ────────────────────────────────────────────────

export function BehaviorSection({
  enableQuantitySelector,
  onEnableQuantitySelectorChange,
  hideCloseIcon,
  onHideCloseIconChange,
  hideVariantSelector,
  onHideVariantSelectorChange,
}: {
  enableQuantitySelector: boolean;
  onEnableQuantitySelectorChange: (v: boolean) => void;
  hideCloseIcon: boolean;
  onHideCloseIconChange: (v: boolean) => void;
  hideVariantSelector: boolean;
  onHideVariantSelectorChange: (v: boolean) => void;
}) {
  return (
    <CollapsibleSectionCard
      header={<SectionHeader number={6} title="Comportamiento" />}
    >
      <s-stack direction="block" gap="base">
        <s-checkbox
          label="Habilitar selector de cantidad"
          checked={enableQuantitySelector}
          onChange={(e: CallbackEvent<"s-checkbox">) =>
            onEnableQuantitySelectorChange(e.currentTarget.checked)
          }
        />
        <Divider />
        <s-checkbox
          label="Ocultar icono de cierre (X)"
          details="El cliente solo podrá cerrar el popup aceptando o rechazando la oferta."
          checked={hideCloseIcon}
          onChange={(e: CallbackEvent<"s-checkbox">) =>
            onHideCloseIconChange(e.currentTarget.checked)
          }
        />
        <Divider />
        <s-checkbox
          label="Ocultar selector de variantes"
          checked={hideVariantSelector}
          onChange={(e: CallbackEvent<"s-checkbox">) =>
            onHideVariantSelectorChange(e.currentTarget.checked)
          }
        />
      </s-stack>
    </CollapsibleSectionCard>
  );
}

// ─── Section 7: Cuenta regresiva ──────────────────────────────────────────────

export function CountdownSection({
  label,
  onLabelChange,
  hours,
  onHoursChange,
  minutes,
  onMinutesChange,
  seconds,
  onSecondsChange,
}: {
  label: string;
  onLabelChange: (v: string) => void;
  hours: number;
  onHoursChange: (v: number) => void;
  minutes: number;
  onMinutesChange: (v: number) => void;
  seconds: number;
  onSecondsChange: (v: number) => void;
}) {
  return (
    <CollapsibleSectionCard
      header={<SectionHeader number={7} title="Cuenta regresiva" />}
    >
      <s-stack direction="block" gap="base">
        <s-text color="subdued">
          Muestra un temporizador en el popup para generar urgencia. Déjalo en
          cero para desactivarlo.
        </s-text>

        <s-text-field
          label="Etiqueta del temporizador"
          value={label}
          placeholder="Ej: ¡Oferta válida por:"
          onInput={(e: CallbackEvent<"s-text-field">) =>
            onLabelChange(e.currentTarget.value)
          }
        />

        <s-grid gridTemplateColumns="1fr 1fr 1fr" gap="base">
          <NumericField
            label="Horas"
            min={0}
            value={hours}
            onChange={onHoursChange}
          />
          <NumericField
            label="Minutos"
            min={0}
            max={59}
            value={minutes}
            onChange={onMinutesChange}
          />
          <NumericField
            label="Segundos"
            min={0}
            max={59}
            value={seconds}
            onChange={onSecondsChange}
          />
        </s-grid>
      </s-stack>
    </CollapsibleSectionCard>
  );
}
